module.exports = __webpack_public_path__ + "static/media/self_assessment_intro.15fe9125.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/self_assessment_intro.svg
// module id = 1910
// module chunks = 0